import mapActions from './mapActions';
 
export default mapActions('approvals', {
    fetchAll_url: data => {
        let type = data.type || 1;
        return `/api/approvals/${data.year}/${data.month}/${type}`;
    }
});